// extracted by mini-css-extract-plugin
var _1 = "MenuItems-moduleMenuItems__Km6SD";
var _2 = "MenuItems-modulecontent__ctsVh";
export { _1 as "MenuItems", _2 as "content" }
